import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeANTitleListItem extends SearchModelBase {
    antitle: string = '';
    antitle1: boolean|null = null;
    antitle1Alt: boolean = false;
    antitle2: boolean|null = null;
    antitle2Alt: boolean = false;
    id: number = 0;
    cid: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'A/N Title', width: 500, dataIndex: 'antitle'}),
        XCol.Create({ col: 1, text: 'Show Charge', width: 100, dataIndex: 'antitle1', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 2, text: 'ACN', width: 50, dataIndex: 'antitle2', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeANTitleListItem.prototype.antitle, orderByAscending: false };

    public static formatData(data: CodeANTitleListItem[]) {
        return data.map((d: CodeANTitleListItem) => ({
          ...d,
        }));
    }

}
